// extracted by mini-css-extract-plugin
export default {"keyIcon":"keyIcon__vQBSvf","keywordsOffButton":"keywordsOffButton__FLYVr7","keywordsOnButton":"keywordsOnButton__aXmtbs"};